import isEmpty from "lodash/isEmpty";
import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";
import { useListSpaceGroups } from "../hooks/useListSpaceGroups";
import type { SpaceGroup } from "../types/space";
import { SpaceGroupListItem } from "./SpaceGroupListItem";
import { SkeletonLoader } from "./common/SkeletonLoader";

export const SpaceGroupList = () => {
  const { isLoading, data } = useListSpaceGroups();

  const spaceGroups = data?.records || [];

  if (isLoading) {
    return (
      <div className="space-y-3">
        <SkeletonLoader width="50px" />
        <SkeletonLoader rows={5} />
      </div>
    );
  }

  if (isEmpty(spaceGroups)) {
    return (
      <div className="px-6">
        <Typography.BodyMd>
          {t("support_widget.no_spaces_found")}
        </Typography.BodyMd>
      </div>
    );
  }

  return (
    <div className="mb-4 overflow-auto">
      <div className="mt-1.5">
        {spaceGroups.map((spaceGroup: SpaceGroup) => (
          <SpaceGroupListItem spaceGroup={spaceGroup} key={spaceGroup.id} />
        ))}
      </div>
    </div>
  );
};
